<template>
  <section class="modal fade" id="video-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content modal-popup">
        <div class="modal-header">
          <button type="button" class="close" aria-label="Close" v-on:click="close_modal()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <iframe v-bind:src="src" frameborder="0" allowfullscreen></iframe>
        </div>
      </div>
    </div>
  </section>
  <div class="modal-backdrop fade" id="backdrop" style="visibility: hidden;"></div>
</template>

<script>
export default {
  name: "modal_video",
  data(){
    return {
      src:'',
    }
  },
  methods:{
    open_modal(src){
      this.src=src;
      document.getElementById("backdrop").style.visibility="visible";
      document.getElementById("backdrop").classList.add("in");
      document.getElementById("backdrop").classList.add("show");
      document.getElementById("video-modal").classList.add("in");
      document.getElementById("video-modal").classList.add("show");
      window.addEventListener('click', this.window_event, false);
    },
    close_modal(){
      this.src='';
      document.getElementById("backdrop").classList.remove("show");
      document.getElementById("backdrop").classList.remove("in");
      document.getElementById("video-modal").classList.remove("show");
      document.getElementById("video-modal").classList.remove("in");
      document.getElementById("backdrop").style.visibility="hidden";
      window.removeEventListener('click', this.window_event, false);
    },
    window_event(event){
      let modal = document.getElementById('video-modal');
      if (event.target === modal) {
        this.close_modal();
      }
    }
  }
}
</script>

<style scoped>

</style>